<template>
    <div class="topicAdd">
        <el-breadcrumb class="bread-nav" separator="/">
            <el-breadcrumb-item>首页</el-breadcrumb-item>
            <el-breadcrumb-item>话题PK</el-breadcrumb-item>
            <el-breadcrumb-item>添加话题</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="topic-add-box">
            <el-form :model="addTopicForm" :rules="validateRules" ref="addTopicForm" label-width="100px" class="addTopicForm">
                <el-form-item label="话题名称" prop="topicTitle">
                    <el-input v-model="addTopicForm.topicTitle" auto-complete="off" placeholder="请输入话题名称"></el-input>
                </el-form-item>
                <el-form-item label="焦点图类别" prop="focusImgType">
                    <el-select v-model="addTopicForm.focusImgType" placeholder="请选择">
                      <el-option v-for="typeItem in focusImgType" :key="typeItem.value" :label="typeItem.label" :value="typeItem.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="addTopicForm.focusImgType === 'image'" label="焦点图" prop="focusImgUrl">
                    <el-input v-model="addTopicForm.focusImgUrl" auto-complete="off" placeholder="请输入焦点图地址"></el-input>
                </el-form-item>
                <el-form-item v-if="addTopicForm.focusImgType === 'video'" label="焦点视频" prop="focusImgUrl">
                    <el-input v-model="addTopicForm.focusImgUrl" auto-complete="off" placeholder="请输入焦点图地址"></el-input>
                </el-form-item>
                <el-form-item v-if="addTopicForm.focusImgType === 'video'" label="视频封皮"prop="focusVideoPoster">
                    <el-input v-model="addTopicForm.focusVideoPoster" auto-complete="off" placeholder="请输入视频封皮地址"></el-input>
                </el-form-item>
                <el-form-item label="话题内容" prop="topicContent">
                    <el-input v-model="addTopicForm.topicContent" type="textarea" auto-complete="off" placeholder="请输入话题内容（选填）"></el-input>
                </el-form-item>
                <el-form-item label="参与人数" prop="participants">
                    <el-input v-model="addTopicForm.participants" auto-complete="off" placeholder="请输入参与人数（选填）"></el-input>
                </el-form-item>
                <el-form-item label="开启分享" prop="isShare">
                    <el-switch v-model="addTopicForm.isShare" on-value="1" off-value="0">
                    </el-switch>
                </el-form-item>
                <template v-if="Number(addTopicForm.isShare)">
                    <!--<el-form-item label="分享链接" prop="shareUrl">-->
                      <!--<el-input v-model="addTopicForm.shareUrl" auto-complete="off" placeholder="请输入分享链接（选填）"></el-input>-->
                    <!--</el-form-item>-->
                    <el-form-item label="分享图（尺寸200*200）" prop="shareImgUrl">
                      <el-input v-model="addTopicForm.shareImgUrl" auto-complete="off" placeholder="请输入分享图地址"></el-input>
                    </el-form-item>
                    <el-form-item label="分享标题" prop="shareTitle">
                      <el-input v-model="addTopicForm.shareTitle" auto-complete="off" placeholder="请输入分享标题"></el-input>
                    </el-form-item>
                    <el-form-item label="分享描述" prop="shareDes">
                      <el-input v-model="addTopicForm.shareDes" type="textarea" auto-complete="off" placeholder="请输入分享描述"></el-input>
                    </el-form-item>
                </template>
                <el-form-item>
                    <el-button type="primary" @click="addTopic('addTopicForm')">立即创建</el-button>
                    <el-button @click="clearTopicData()">重置</el-button>
                </el-form-item>
            </el-form>
            <div class="topic-preview-box">
                <div class="header-image" v-if="addTopicForm.focusImgUrl !== null && addTopicForm.focusImgUrl !== ''">
                    <img v-if="addTopicForm.focusImgType === 'image'" :src="addTopicForm.focusImgUrl" alt="请输入正确的图片地址">
                    <video v-if="addTopicForm.focusImgType === 'video'" :src="addTopicForm.focusImgUrl" :poster="addTopicForm.focusVideoPoster" controls></video>
                </div>
                <div class="description" v-if="addTopicForm.topicTitle !== null && addTopicForm.topicTitle !== ''">
                    <!--<div class="desc-icon">概述</div>-->
                    <h5>{{addTopicForm.topicTitle}}</h5>
                    <span class="desc-content" v-if="addTopicForm.topicContent !== null && addTopicForm.topicContent !== ''">{{addTopicForm.topicContent}}</span>
                </div>
                <div class="say-sth" v-if="addTopicForm.topicTitle !== null && addTopicForm.topicTitle !== ''">
                    <img src="http://tstatic.toptest.yidianzixun.com.ks3-cn-beijing.ksyun.com/public/files/ydlg1495784109418.jpeg">
                    <span>一点资讯用户</span>
                    <div>说点什么</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CONFIG from "@/config/index.js";
import TOOL from '@/tool/index.js';
import router from "@/router/index.js";
import { mapGetters } from 'vuex';
export default {
    name: 'topicAdd',
    data () {
        var imgUrl = (rule, value, callback) => {
            console.log(value);
            var regImage = new RegExp('^http://'),
                regVideo = new RegExp('^https://');
            if (value == '' || value == '请输入焦点图地址' || value == '请填写分享图片地址') {
                callback(new Error('请填写图片地址'));
            } else if (! regImage.test(value) && !regVideo.test(value)) {
                callback(new Error('您填写的地址不正确'));
            } else {
                callback();
            }
        }
        return {
            addTopicForm: {
                topicTitle: '',
                topicContent: '',
                participants: '0',
                createUser: -1,
                focusImgUrl: '',
                isShare: '0',
                shareTitle: '',
                shareDes: '',
                shareUrl: '',
                shareImgUrl: '',
                focusImgType: null,
                focusVideoPoster: null
            },
            focusImgType: [
              {
                value: 'image',
                label: '图片'
              },
              {
                value: 'video',
                label: '视频'
              }
            ],
            validateRules: {
                topicTitle: [
                    { required: true, message: '请填写话题标题', trigger: 'change' }
                ],
                focusImgUrl: [
                    { required: true, validator: imgUrl, trigger: 'change' }
                ],
                shareDes: [
                    { required: true, message: '请填写分享描述', trigger: 'change' }
                ],
                shareTitle: [
                    { required: true, message: '请填写分享标题', trigger: 'change' }
                ],
                shareImgUrl: [
                    { required: true, validator: imgUrl, trigger: 'change' }
                ],
                focusImgType: [
                    { required: true, message: '请选择焦点图类别', trigger: 'change' }
                ],
                focusVideoPoster: [
                    { required: true, validator: imgUrl, trigger: 'change' }
                ],
                topicContent: [
                    { required: true, message: '请填写话题内容', trigger: 'change' }
                ]
            }
        }
    },
    computed: {
        ...mapGetters({
            userInfo: 'getUserInfo'
        })
    },
    methods: {
        addTopic(formName) {
            let flag = true,
                addTopicForm = {};
            this.$refs[formName].validate((valid) => {
                console.log(valid);
                if (!valid) {
                    flag = false;
                    return false;
                }
            });
            if (!flag) {
                this.$notify.error({
                    message: '请检查要添加的数据'
                });
                return;
            }
            this.addTopicForm.isShare = Number(this.addTopicForm.isShare);
            this.addTopicForm.createUser = this.userInfo.userId;
            for (var key in this.addTopicForm) {
              if (key === 'focusImgUrl' && this.addTopicForm.focusImgType === 'video') {
                addTopicForm.focusImgUrl = this.addTopicForm[key] + "?poster=" + encodeURIComponent(this.addTopicForm['focusVideoPoster']);
              } else {
                addTopicForm[key] = this.addTopicForm[key];
              }
            }
            this.$http.post(CONFIG.HOST + '/topicPK/topics/addTopic', addTopicForm).then((response) => {
                let result = response.body;
                if (result && result.status === 1) {
                    this.$notify.success({
                        message: '【营销平台】话题PK创建成功'
                    });
                    this.clearTopicData();
                    router.push({
                        name: 'topicList'
                    });
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response) => {
                console.log(response);
            });
        },
        clearTopicData() {
            this.$refs.addTopicForm.resetFields();
        }
    }
}
</script>

<style lang="less">
.topicAdd {
    width: 98%;
    margin: 0 auto;
    .el-form-item__label {
        font-weight: bold;
    }
    .el-switch {
        position: absolute;
        left: 0;
        top: 7px;
    }
    .bread-nav {
        margin: 20px 0;
    }
    .topic-add-box {
        width: 980px;
        position: relative;
        left: 0;
        top: 0;
        .addTopicForm {
            width: 440px;
            position: absolute;
            left: 0;
            top: 0;
            .selectForm {
                width: 100%;
            }
            .el-select{
              width: 100%;
            }
        }
        .topic-preview-box {
            width: 360px;
            height: 540px;
            border: 1px solid #bfcbd9;
            border-radius: 6px;
            position: absolute;
            left: 550px;
            top: 0;

            .header-image {
                width: 100%;
                display: block;
                img {
                    width: 100%;
                }
                video{
                  width: 100%;
                }
            }
            .description {
                padding: 10px 11px;
                font-size: 100%;
                text-align: center;
                border-bottom: 3px solid #CFCFCF;
                h5 {
                    margin-bottom: 5px;
                }
                .desc-content {
                    color: #9C9C9C;
                    font-size: 10px;
                    word-break: break-all;
              }
            }
            .say-sth {
                border: 2px dashed #9C9C9C;
                width: 140px;
                height: 140px;
                margin: 20px;
                img {
                    width: 18px;
                    border-radius: 50%;
                    float: left;
                    margin: 5px 0 5px 5px;
                }
                span {
                    font-size: 12px;
                    float: left;
                    margin: 5px;
                }
                div {
                    margin-top: 64px;
                    font-size: 14px;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// Add.vue?1b738a42